import * as amplitude from '@amplitude/analytics-browser';
import { getEnv } from 'common-nextjs';
import { addHours } from 'date-fns';
import { sha1 } from 'js-sha1';
import { sha256 } from 'js-sha256';
import { getKnownCookie, setKnownCookie } from '~/hooks/cookies';
import fireGAEvent from '~/services/analytics/fireGAEvent';
import fireImpactEvent from '~/services/analytics/fireImpactEvent';
import identifySentryUser from '~/services/sentry/identifyUser';
import { getSentry } from '~/services/sentry/wrapper';

export const trackingIdentifyAnonymous = () => {
  fireImpactEvent('identify', {
    customerId: '',
    customerEmail: '',
  });
};

export async function trackingIdentify(user: {
  username: string;
  external_id: string;
  email?: string;
  phoneNumber?: string;
}) {
  if (!user) {
    return;
  }

  if (getEnv() !== 'production') {
    console.log('Analytics identified', user);
  }

  getSentry()?.setUser(identifySentryUser(user));

  if (amplitude) {
    amplitude.setUserId(user.external_id);

    const identifyEvent = new amplitude.Identify();
    identifyEvent.set('username', user.username);

    amplitude.identify(identifyEvent);
  }

  if (getEnv() === 'production') {
    fireImpactEvent('identify', {
      customerEmail: user.email ? sha1(user.email) : '',
      customerId: user.external_id || '',
    });

    fireGAEvent('set', 'userId', user.external_id);

    if (window.ttq) {
      window.ttq.identify({
        email: user.email ? sha256(user.email) : undefined,
        phone_number: user.phoneNumber ? sha256(user.phoneNumber) : undefined,
        external_id: user.external_id,
      });
    }
  }
}

export const trackingUnidentify = () => {
  // Use Browser SDK 2 reset method
  amplitude.reset();
};

export function isFirstVisit() {
  const hasVisited = getKnownCookie(null, 'sls_fv');
  if (!hasVisited) {
    function setCookie() {
      setKnownCookie(null, 'sls_fv', '1', {
        expires: addHours(new Date(), 18),
      });
    }

    addEventListener('visibilitychange', setCookie, {
      once: true,
    });
    addEventListener('beforeunload', setCookie, {
      once: true,
    });
    addEventListener('popstate', setCookie, {
      once: true,
    });

    setTimeout(setCookie, 1500);
  }

  // if you have not yet visited, then it's your first visit (1)

  if (hasVisited) {
    return '0';
  } else {
    return '1';
  }
}
